import { FieldPolicy } from '@apollo/client';
import { AutoImport } from '../models/graphql';

const sortImports = (a: AutoImport, b: AutoImport, readField: CallableFunction): number => {
  const nameA = readField('name', a) as string | undefined;
  const nameB = readField('name', b) as string | undefined;

  // Return the comparison result
  return (nameA ?? '').localeCompare(nameB ?? '');
};

export const autoImportsPolicy = (): FieldPolicy => {
  return {
    keyArgs: [],
    read(existing: AutoImport[] | undefined, { readField }): AutoImport[] | undefined {
      if (typeof existing === 'undefined') {
        return undefined;
      }

      return Array.from(existing)
        .filter(autoImport => !readField('archived', readField('category', autoImport)))
        .sort((a, b) => sortImports(a, b, readField));
    }
  };
};
